<template>
  <div class="xyk-price-component">
    <!-- 表格区域 -->
    <div class="table-container">
      <el-table 
        :data="tableData" 
        border 
        stripe 
        v-loading="loading"
        element-loading-text="数据加载中..." 
        element-loading-spinner="el-icon-loading"
        highlight-current-row 
        @current-change="$emit('current-change', $event)"
        :height="tableHeight" 
        style="width: 100%"
        :key="componentKey"
      >
        
        <el-table-column fixed="left" label="行号" type="index" width="60" align="center"></el-table-column>
        
        <el-table-column 
          v-for="(col, index) in tableColumns" 
          :key="index" 
          :prop="col.prop" 
          :label="col.name" 
          :width="getColumnWidth(col)"
          :show-overflow-tooltip="true" 
          align="center"
        >
        </el-table-column>
        
        <!-- 操作列 -->
        <el-table-column fixed="right" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="$emit('detail-click', scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="$emit('size-change', $event)"
        @current-change="$emit('current-change', $event)"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XykPrice',
  props: {
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 加载状态
    loading: {
      type: Boolean,
      default: false
    },
    // 表格高度
    tableHeight: {
      type: Number,
      default: 400
    },
    // 分页信息
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 10,
        total: 0
      })
    },
    // 当前选中的药房ID
    currentDepotId: {
      type: [String, Number],
      default: 1
    }
  },
  data() {
    return {
      componentKey: 0, // 用于强制重新渲染组件
      // 表格列配置
      tableColumns: [
        { name: "单据编号", prop: "adjustNum" },
        { name: "创建时间", prop: "createTime" },
        { name: "创建人", prop: "createName" },
        { name: "药品名称", prop: "drugName" },
        { name: "调前成本单价", prop: "agoPurcPric" },
        { name: "调前零售单价", prop: "agoSalePric" },
        { name: "调后成本单价", prop: "afrPurcPric" },
        { name: "调后零售单价", prop: "afrSalePric" },
      ]
    };
  },
  watch: {
    // 监听药房ID变化，重新渲染组件
    currentDepotId: {
      handler(newVal) {
        console.log('药房切换:', newVal);
        this.componentKey += 1; // 强制重新渲染
        this.$emit('depot-change', newVal);
      },
      immediate: true
    }
  },
  methods: {
    // 计算列宽
    getColumnWidth(col) {
      const baseWidth = 100;
      const text = col.name;
      let maxWidth = this.calcTextWidth(text);
      
      // 遍历数据找出最长的内容
      this.tableData.forEach(row => {
        if (row[col.prop]) {
          const cellWidth = this.calcTextWidth(String(row[col.prop]));
          if (cellWidth > maxWidth) {
            maxWidth = cellWidth;
          }
        }
      });
      
      return Math.max(baseWidth, maxWidth + 20);
    },
    
    // 计算文本宽度
    calcTextWidth(str) {
      if (!str) return 0;
      let length = 0;
      for (const char of String(str)) {
        if ("a" <= char && char <= "z") length += 8;
        else if ("A" <= char && char <= "Z") length += 8;
        else if (Number.isFinite(Number(char))) length += 8;
        else if (char >= "\u4e00" && char <= "\u9fa5") length += 16;
        else length += 8;
      }
      return length;
    }
  }
};
</script>

<style lang="less" scoped>
.xyk-price-component {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .table-container {
    flex: 1;
    overflow: hidden;
  }
  
  .pagination-container {
    padding: 16px 0;
    border-top: 1px solid #e6e6e6;
    background: #fafbfc;
    display: flex;
    justify-content: flex-end;
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .xyk-price-component {
    .table-container {
      overflow-x: auto;
      
      /deep/ .el-table {
        min-width: 800px; // 确保表格在移动端可以横向滚动
      }
    }
    
    .pagination-container {
      padding: 12px 0;
      
      /deep/ .el-pagination {
        .btn-prev,
        .btn-next,
        .el-pager li {
          min-width: 32px;
          height: 32px;
          line-height: 32px;
        }
        
        .el-pagination__jump {
          display: none; // 移动端隐藏跳转输入框
        }
      }
    }
  }
}

// 超小屏幕优化
@media screen and (max-width: 480px) {
  .xyk-price-component {
    .pagination-container {
      /deep/ .el-pagination {
        .el-pagination__sizes {
          display: none; // 超小屏幕隐藏页面大小选择
        }
      }
    }
  }
}
</style>